<template>
    <div class="store-dialog">
        <div class="filters-container">
			<div class="input-box">
				<span>店铺名称：</span>
				<el-input
					v-model="shopName"
					placeholder="请输入店铺名称"
					class="filter-input"
					size="small"
					@keyup.enter.native="search"
				></el-input>
			</div>
			<el-button size="small" type="primary" plain class="btn" @click="search">查询</el-button>
		</div>
		<div class="main-table">
			<div class="main-table-box">
				<el-table
					class="grid-content"
					:data="tableData"
					border
					stripe
					:height="tableHeight"
					@selection-change="selectionChangeHandle"
				>
					<el-table-column
						type="selection"
						align="center"
						width="55">
					</el-table-column>
					<el-table-column
						prop="name"
						label="店铺名称"
						align="center">
					</el-table-column>
					<el-table-column
						prop="code"
						label="店铺编号"
						align="center">
					</el-table-column>
				</el-table>
			</div>
			<el-pagination
				@size-change="handleSizeChange"
				@current-change="handlePageChange"
				:current-page="pagination.page"
				:page-sizes="[20,40, 60, 100]"
				:page-size="pagination.size"
				layout="total, sizes, prev, pager, next, jumper"
				:total="totalCount">
			</el-pagination>
		</div>
		<div class="btn-box">
			<el-button class="btn" plain type="primary" @click="cancel">取消</el-button>
			<el-button class="btn" type="primary" v-show="true" @click="confirm">确认</el-button>
		</div>
    </div>
</template>

<script>
export default {
	name: 'storeDialog',
	props: {
		visible: {
			type: Boolean
		}
	},
	data () {
		return {
			shopName: '',
			tableHeight: '100%',
			pagination: {
				page: 1,
				size: 20
			},
			tableData: [],
			totalCount: 0,
			ids: []
		}
	},
	created () {
		this.getInfo()
	},
	methods: {
		selectionChangeHandle (value) {
			this.ids = value.map(item => {
				return item.id
			})
		},
		handleSizeChange (value) {
			this.pagination.size = value
			this.getInfo()
		},
		handlePageChange (value) {
			this.pagination.page = value
			this.getInfo()
		},
		cancel () {
			this.$emit('update:visible', false)
		},
		search () {
			this.getInfo()
		},
		getInfo () {
			let params = {
				id: sessionStorage.getItem('goodsid'),
				shopName: this.shopName,
				comFlag: 1,
				size: this.pagination.size,
				page: this.pagination.page,
				order: 1,
				orderKey: ''
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getShopInfoOfProduct`,
				data: params
			}).then(res => {
				if (res.result) {
					this.totalCount = res.data.recordCount
					this.tableData = res.data.recordList
				}
			})
		},
		confirm () {
			if (this.ids.length < 1) {
				this.$message.error('请至少选择一个门店！')
				return false
			}
			let params = {
				ids: sessionStorage.getItem('goodsid'),
				shopIds: '' + this.ids
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/saveShopRelationGoods`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('关联门店成功！')
					this.$emit('relateSuc')
				} else {
					this.$message.warning(res.msg)
				}
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.store-dialog {
	height: 400px
	display flex
	flex-direction column
	.filters-container {
		display flex
		.input-box {
			display flex
			width: 250px
			margin-left: 20px
			span {
				margin-right: 10px
				line-height 32px
			}
			.filter-input {
				flex: 1
			}
		}
		.btn {
			height: 32px
			margin-left 20px
		}
	}
	.main-table {
		display flex
		flex: 1
		flex-direction: column
		padding: 10px 0 0 0
		text-align center
		.main-table-box {
			flex: 1
			margin-bottom 10px
			overflow-y: auto;
		}
	}
	.btn-box {
		padding: 20px 0 0 0
		text-align center
		.btn {
			width: 200px
		}
	}
}
</style>
